import gql from 'graphql-tag';

// ポイント履歴取得
export const GET_POINT_HISTORY = gql`
    query ($golf_group_code: String!, $golf_code: String, $point_type: Int, $history_begin_row: Int, $history_limit_rows: Int, $display_flag: Int) {
        memberGetPointList(
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            point_type: $point_type,
            begin_row: $history_begin_row,
            limit_rows: $history_limit_rows
            display_flag: $display_flag
        )
        {
            PointList {
                id
                processing_date
                point_type
                point_type_display
                action
                point
                comment
            }
            count
        }
    }
`;

export const USE_POINT = gql`
    mutation(
        $PointList: [UseWebPoint]
    ){
    usePointLinkByMemberNo(
        UsePointList: $PointList
    )
    {
    result
    }
  }
`;

export const RESERVE_USE_POINT_CANCEL = gql`
    mutation(
        $CancelPointByMemberNo: [CancelPointByMemberNo]
    ){
    cancelPointLinkByMemberNo(
        CancelPointList: $CancelPointByMemberNo
    ){
    result
    }
  }
`;

export const GET_GOLF_COURSE_POINT_HISTORY = gql`
    query(
        $member_no: ID!,
        $golf_group_code: String!,
        $golf_code: String,
        $point_type: Int,
        $history_begin_row: Int,
        $history_limit_rows: Int,
        $display_flag: Int
    ) {
        getGolfCoursePointHistory(
            member_no: $member_no
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            point_type: $point_type
            history_begin_row: $history_begin_row
            history_limit_rows: $history_limit_rows
            display_flag: $display_flag
        )
        {
            totalPoint{
                total_all
                total_normal
                total_limited_normal
                total_limited
                total_expected
                total_reserve
            }
            validDate{
                total_limited_normal
                total_limited
                expected_date
                play_date
            }
            pointList{
                id
                processing_date
                point_type
                point_type_display
                action
                point
                comment
            }
            count
        }
    }
`;
